import React, { useContext, useEffect } from 'react'
import Products from '../Products/Products'
import OfferSlider from '../OfferSlider/OfferSlider'
import CategorySlider from '../CategorySlider/CategorySlider'
import { Helmet } from 'react-helmet'
export default function Home() {
 
  
  return <>
  
  <Helmet>
        <title>Home</title>
        
    </Helmet>
    <OfferSlider/>
    <CategorySlider/>
   
    <Products/>
    
  
  
  </>
}
